import type { ReactNode } from 'react';
import { Text, cn } from '@billda/design-system';

interface FinancialSummaryRowProps {
  label: string;
  value: ReactNode;
  valueColor?:
    | 'primary'
    | 'error'
    | 'success'
    | 'text.primary'
    | 'text.secondary';
  emphasis?: boolean;
  dividerAbove?: boolean;
  className?: string;
}

const valueColorClasses: Record<string, string> = {
  primary: 'text-content-primary',
  error: 'text-content-error',
  success: 'text-content-success',
  'text.primary': 'text-content-primary',
  'text.secondary': 'text-content-secondary',
};

export function FinancialSummaryRow({
  label,
  value,
  valueColor = 'text.primary',
  emphasis = false,
  dividerAbove = false,
  className,
}: FinancialSummaryRowProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between',
        dividerAbove && 'border-t border-border-default pt-2',
        className
      )}
    >
      <Text
        variant={emphasis ? 'body1' : 'body2'}
        color={emphasis ? 'primary' : 'secondary'}
        className={emphasis ? 'font-medium' : undefined}
      >
        {label}
      </Text>
      <Text
        as={emphasis ? 'h6' : 'p'}
        variant={emphasis ? 'h6' : 'body1'}
        className={cn(
          emphasis ? 'font-bold' : 'font-medium',
          valueColorClasses[valueColor]
        )}
      >
        {value}
      </Text>
    </div>
  );
}
